module.exports = __webpack_public_path__ + "fonts/10595a1.otf";